import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFField from "../../../Form/RFField";
import RFForm from "../../../Form/RFForm";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";
import SelectField from "../../../Form/SelectField";

const targetSelectOptions = [
  { value: "_self", label: "A jelenlegi ablakban" },
  { value: "_blank", label: "Új ablakban" },
];

const ToolbarLink = () => {
  const { editor } = useEditorContext();

  const [modal, setModal] = useState(false);
  const [link, setLink] = useState("");
  const [label, setLabel] = useState("");
  const [target, setTarget] = useState(targetSelectOptions[0]);

  const toggle = () => {
    setModal(!modal);
    setLink("");
    setLabel("");
    setTarget(targetSelectOptions[0]);
  };

  const handleSubmit = () => {
    editor
      .chain()
      .focus()
      .extendMarkRange("link")
      .setLink({ href: link, target: target.value })
      .command(({ tr }) => {
        tr.insertText(label);
        return true;
      })
      .run();

    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`link-item`}
        tooltip={`Link beszúrása`}
        active={false}
        onToggle={toggle}
        icon={<i className="fa fa-link" aria-hidden="true" />}
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Link beszúrása</ModalHeader>
          <ModalBody>
            <RFField
              id="link"
              name="link"
              type="text"
              label="Link"
              value={link}
              onChange={(e, v) => setLink(v)}
              required
            />
            <RFField
              id="label"
              name="label"
              type="text"
              label="Link szövege"
              value={label}
              onChange={(e, v) => setLabel(v)}
              required
            />
            <SelectField
              label="Hol nyíljon meg?"
              name="target"
              id="target"
              onChange={setTarget}
              isClearable={false}
              isLoading={false}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              value={target}
              cache={false}
              options={targetSelectOptions}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary">OK</Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

export default ToolbarLink;
